module.exports = __webpack_public_path__ + "img/electric_reserved.27223468.svg";